import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import loadable from '@loadable/component';
import Modal from '../Modal/Modal';
import Button from '../form-elements/Button';
import { markProductWithdrawn, refetchOrders } from '../../../modules/actions/account/orders';

const WiderrufForm = loadable(() => import('./WiderrufForm'));

function WiderrufModal({ children, initialValues, variant = 'footer' }) {
    const dispatch = useDispatch();
    const handleSubmitSuccess = useCallback(
        async ({ orderId, productId } = {}) => {
            if (variant !== 'account' || !orderId || !productId) return;
            dispatch(markProductWithdrawn({ orderId, productId }));
            await dispatch(refetchOrders());
        },
        [dispatch, variant]
    );

    const [isReasonOpen, setIsReasonOpen] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [reason, setReason] = useState('');
    const [reasonError, setReasonError] = useState('');
    const reasonFocusRef = useRef(null);

    useEffect(() => {
        if (isReasonOpen && reasonFocusRef.current) {
            reasonFocusRef.current.focus();
        }
    }, [isReasonOpen]);

    const closeAll = () => {
        setIsReasonOpen(false);
        setIsFormOpen(false);
        setReason('');
        setReasonError('');
    };

    const openFlow = () => {
        if (variant === 'account') setIsReasonOpen(true);
        else setIsFormOpen(true);
    };

    const handleProceedFromReason = () => {
        const trimmed = String(reason ?? '').trim();
        if (!trimmed) {
            setReasonError('Bitte geben Sie einen Grund für die Rücksendung ein.');
            return;
        }
        setReasonError('');
        setIsReasonOpen(false);
        setIsFormOpen(true);
    };

    return (
        <>
            {children({ openModal: openFlow })}

            {variant === 'account' && (
                <Modal isOpen={isReasonOpen} onRequestClose={closeAll} contentLabel="Widerruf einleiten">

                    <div className="uk-modal-body uk-form-stacked">
                        <label className="uk-form-label" htmlFor="widerruf-reason">
                            Warum wollen Sie die Ware zurücksenden? <span className="uk-text-danger">*</span>
                        </label>

                        <div className="uk-margin">
                            <textarea
                                ref={reasonFocusRef}
                                id="widerruf-reason"
                                className="uk-textarea"
                                rows={4}
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                required
                                aria-required="true"
                                aria-invalid={Boolean(reasonError)}
                                aria-describedby="widerruf-reason-hint widerruf-reason-error"
                                placeholder="Beschreiben Sie den Grund"
                            />
                            <div id="widerruf-reason-hint" className="uk-text-small uk-margin-small-top">
                                *Pflichtfeld
                            </div>
                            {reasonError && (
                                <div id="widerruf-reason-error" className="uk-text-danger uk-text-small" role="alert">
                                    {reasonError}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="uk-modal-footer">
                        <div className="uk-grid uk-grid-small widerruf-modal-actions" data-uk-grid="">
                            <div className="uk-width-1-2">
                                <Button fullWidth className="widerruf-action-button" onClick={handleProceedFromReason}>
                                    WIDERRUF EINLEITEN
                                </Button>
                            </div>
                            <div className="uk-width-1-2">
                                <Button fullWidth className="widerruf-action-button" onClick={closeAll}>
                                    VORGANG ABBRECHEN
                                </Button>
                            </div>
                        </div>
                    </div>
                </Modal>
            )}

            <Modal isOpen={isFormOpen} onRequestClose={closeAll} contentLabel="Vertrag widerrufen">
                <WiderrufForm
                    initialValues={{ ...initialValues, reason }}
                    closeModal={closeAll}
                    onSubmitSuccess={handleSubmitSuccess}
                />
            </Modal>
        </>
    );
}

export default WiderrufModal;
